import styled, { css } from 'styled-components';
import { FlexBetween } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';

const authorStyles = css`
  flex-direction: column;
  gap: 10px;
`;

const notAuthorStyles = css`
  margin-top: 20px;
  gap: 18px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-top: 30px;
    gap: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-top: 0;
    gap: 5px;
  }
`;

export const PromotionButtonsContainer = styled(FlexBetween)<{
  $isAuthor: boolean;
}>`
  ${({ $isAuthor }) => ($isAuthor ? authorStyles : notAuthorStyles)}
`;
